/** Calculate the next two weekdays using the current UK calendar date. */
export function dispatchWindow(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
  }).formatToParts(now);
  const part = (type) => Number(parts.find((value) => value.type === type).value);
  const candidate = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
  const dates = [];
  while (dates.length < 2) {
    candidate.setUTCDate(candidate.getUTCDate() + 1);
    if (candidate.getUTCDay() !== 0 && candidate.getUTCDay() !== 6) {
      dates.push(new Date(candidate));
    }
  }
  const [start, end] = dates;
  const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
  const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
  const format = (date, options) => new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', ...options,
  }).format(date);
  return {
    startISO: start.toISOString().slice(0, 10),
    endISO: end.toISOString().slice(0, 10),
    startLabel: format(start, sameMonth ? { day: 'numeric' } : {
      day: 'numeric', month: 'long', ...(!sameYear && { year: 'numeric' }),
    }),
    endLabel: format(end, {
      day: 'numeric', month: 'long', ...(!sameYear && { year: 'numeric' }),
    }),
  };
}

if (typeof customElements !== 'undefined' && !customElements.get('wl-dispatch-date')) {
  class DispatchDate extends HTMLElement {
    connectedCallback() {
      this.update();
      this.refreshTimer = setInterval(() => this.update(), 60000);
    }

    disconnectedCallback() {
      clearInterval(this.refreshTimer);
    }

    update() {
      const dates = dispatchWindow();
      const start = this.querySelector('[data-dispatch-start]');
      const end = this.querySelector('[data-dispatch-end]');
      if (!start || !end) return;
      start.dateTime = dates.startISO;
      start.textContent = dates.startLabel;
      end.dateTime = dates.endISO;
      end.textContent = dates.endLabel;
    }
  }
  customElements.define('wl-dispatch-date', DispatchDate);
}
